import KeyCabinetUniversal from 'containers/KeyCabinet/Universal'
import MapDetails from 'layouts/Desktop/containers/MapDetails'
import { Switch, Redirect, Route } from 'react-router-dom'
import GateGateway from 'containers/entrance/GateGateway'
import Registration from 'containers/forms/Registration'
import SubMenu from './containers/Warehouse/SubMenu'
import PaymentStatus from 'containers/PaymentStatus'
import OrderContract from 'containers/OrderContract'
import OrderSummary from 'containers/OrderSummary'
import NewWarehouse from 'containers/NewWarehouse'
import FirstOpening from 'containers/FirstOpening'
import OrderDetails from 'containers/OrderDetails'
import RestoreOrder from 'containers/RestoreOrder'
import OAuthFinish from 'containers/OAuth/Finish'
import Contract from 'containers/forms/Contract'
import Warehouses from './containers/Warehouses'
import Shared from 'containers/entrance/Shared'
import Warehouse from './containers/Warehouse'
import Billing from 'containers/forms/Billing'
import Categories from 'containers/Categories'
import PayInvoice from 'containers/PayInvoice'
import KeyCabinet from 'containers/KeyCabinet'
import MagMobile from 'containers/MagMobile'
import Dashboard from 'containers/Dashboard'
import Google from 'containers/OAuth/Google'
import DesktopMRoute from './DesktopMRoute'
import Apple from 'containers/OAuth/Apple'
import Reset from 'containers/forms/Reset'
import AccountRecovery from 'containers/forms/AccountRecovery'
import Account from './containers/Account'
import PlaceMap from 'containers/PlaceMap'
import StartPage from 'layouts/StartPage'
import Payment from 'containers/Payment'
import Help from './containers/Help'
import Login from 'containers/Login'
import Chats from 'containers/Chats'
import Home from 'containers/Home'
import Maps from 'containers/Maps'
import Shop from 'containers/Shop'

const type = process.env.REACT_APP_TYPE
const applicationForExternalCompanies = type !== 'mm' && type !== 'box'

const Router = () => {
  return (
    <Switch>
      <DesktopMRoute exact path='/' darkNavBar={false} showMenuOnlyWhenUserIsLoggedIn isFooter={type !== 'box'} showBlankPageOnlyIfUserIsNotLogIn={type === 'box'} isHeader={type !== 'box'}>
        <StartPage />
      </DesktopMRoute>

      <DesktopMRoute exact path={['/account/:key/:action', '/account/:key', '/account']} >
        <Account />
      </DesktopMRoute>

      <DesktopMRoute exact path='/categories'>
        <Categories isDesktop />
      </DesktopMRoute>

      <DesktopMRoute exact path={['/chat/:id', '/chat']} maxHeight>
        <Chats />
      </DesktopMRoute>

      <DesktopMRoute exact path='/contract'>
        <Contract isDesktop />
      </DesktopMRoute>

      <DesktopMRoute exact path='/dashboard' protectedPath>
        <Dashboard />
      </DesktopMRoute>

      <Route exact path={['/firstopening/:id/:key', '/firstopening/:id']}>
        <FirstOpening />
      </Route>

      <DesktopMRoute exact path='/help'>
        <Help />
      </DesktopMRoute>

      <DesktopMRoute exact path='/home' darkNavBar={false} showMenuOnlyWhenUserIsLoggedIn isFooter={type !== 'box'} isSearch={type === 'box'} isHeader={type !== 'box'}>
        <Home />
      </DesktopMRoute>

      <DesktopMRoute exact path='/invoices/:id/pay' isMenu={false} isOrder>
        <PayInvoice />
      </DesktopMRoute>

      <DesktopMRoute exact path='/keycabinet' maxHeight protectedPath>
        <KeyCabinetUniversal />
      </DesktopMRoute>

      <DesktopMRoute exact path='/login'>
        <Login isDesktop />
      </DesktopMRoute>

      <DesktopMRoute exact path='/login/recovery'>
        <AccountRecovery />
      </DesktopMRoute>

      <DesktopMRoute exact path='/login/reset'>
        <Reset />
      </DesktopMRoute>

      {type === 'mm' && <DesktopMRoute exact path='/magmobile' darkNavBar isSearch>
        <MagMobile />
      </DesktopMRoute>}

      <DesktopMRoute exact path={['/map/:placeId', '/map']} darkNavBar isSearch isFooter>
        <Maps isMobile={false} />
      </DesktopMRoute>

      {applicationForExternalCompanies
        ? <DesktopMRoute exact path='/mapdetails/:placeId' showMenuOnlyWhenUserIsLoggedIn>
          <MapDetails type='default' />
        </DesktopMRoute>
        : <DesktopMRoute exact path='/mapdetails/:placeId' darkNavBar isSearch>
          <Maps isMobile={false} />
        </DesktopMRoute>}

      <DesktopMRoute exact path={['/newwarehouse/:key/:id', '/newwarehouse/:key', '/newwarehouse']} protectedPath isMenu={false} isOrder>
        <NewWarehouse />
      </DesktopMRoute>

      <DesktopMRoute exact path='/oauth/apple' isBasket isOrder>
        <Apple />
      </DesktopMRoute>

      <DesktopMRoute exact path='/oauth/google' isBasket isOrder>
        <Google />
      </DesktopMRoute>

      <DesktopMRoute exact path='/oauth/finish' isBasket isOrder>
        <OAuthFinish />
      </DesktopMRoute>

      <DesktopMRoute exact path='/odbior-klucza' maxHeight protectedPath>
        <KeyCabinetUniversal purpose='pickup' />
      </DesktopMRoute>

      <DesktopMRoute exact path='/order/billing' protectedPath isBasket isOrder>
        <Billing isDesktop />
      </DesktopMRoute>

      <DesktopMRoute exact path='/order/contract' isBasket isOrder>
        <OrderContract />
      </DesktopMRoute>

      <DesktopMRoute exact path='/order/finalize/:cartId' isBasket isOrder>
        <RestoreOrder />
      </DesktopMRoute>

      <DesktopMRoute exact path='/order/payment' isBasket isOrder>
        <Payment />
      </DesktopMRoute>

      <DesktopMRoute exact path='/order/summary' isBasket isOrder>
        <OrderSummary />
      </DesktopMRoute>

      <DesktopMRoute exact path='/order/:id' isBasket isOrder>
        <OrderDetails isDesktop />
      </DesktopMRoute>

      <DesktopMRoute exact path={['/order/:cartId/equipment/:equipmentId/:categoryId', '/order/:cartId/equipment/:equipmentId', '/order/:cartId/shop/:categoryId', '/order/:cartId/shop', '/shop/:warehouseId', '/shop']} isBasket>
        <Shop isDesktop />
      </DesktopMRoute>

      <DesktopMRoute exact path='/payment/status' isBasket isOrder>
        <PaymentStatus />
      </DesktopMRoute>

      <DesktopMRoute exact path={['/placemap/:placeId/:id', '/placemap/:placeId']} isMenu={false} isOrder>
        <PlaceMap />
      </DesktopMRoute>

      <DesktopMRoute exact path='/registration'>
        <Registration isDesktop />
      </DesktopMRoute>

      <DesktopMRoute exact path='/shared/:hash' isBasket isOrder>
        <Shared />
      </DesktopMRoute>

      <DesktopMRoute exact path='/warehouses' protectedPath>
        <Warehouses />
      </DesktopMRoute>

      <DesktopMRoute exact path={['/warehouses/:id']} maxHeight protectedPath>
        <Warehouse />
      </DesktopMRoute>

      <DesktopMRoute exact path={['/warehouses/:id/gate', '/warehouses/:id/gateway']} maxHeight protectedPath>
        <GateGateway />
      </DesktopMRoute>

      <DesktopMRoute exact path='/warehouses/:id/keycabinet' maxHeight protectedPath>
        <KeyCabinet />
      </DesktopMRoute>

      <DesktopMRoute exact path={['/warehouses/:id/:type/:action/:typeId', '/warehouses/:id/:type/:action', '/warehouses/:id/:type']} maxHeight protectedPath>
        <SubMenu />
      </DesktopMRoute>

      <DesktopMRoute exact path='/zwrot-klucza' maxHeight protectedPath>
        <KeyCabinetUniversal purpose='return' />
      </DesktopMRoute>

      <Redirect to='/' />
    </Switch>
  )
}

export default Router